import SideBar from "./SideBar";
import React, { useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import HeroSection from "../../layout/HeroSection";
import Loader from "../../components/other/Loader";
import ProfileForm from "./components/ProfileForm";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfile } from "../../redux/action/authAction";

const Profile = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.authReducer);

  useEffect(() => {
    dispatch(fetchProfile());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 className="mb-1">{"Profile"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Profile", path: `${pageRoutes?.home}/` },
        ]}
      />
      <div class="untree_co-section ">
        <div class="container">
          <div class="row mb-5">
            {/* <SideBar /> */}

            <ProfileForm />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
